module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_3.be0a2053.svg";